import { Box } from "@mui/material"
import { LocationQueryAutocomplete } from "./LocationAutocomplete"
import { useState } from "react"
import { max, min } from "lodash"
import OotItemContextMenuButton from "./OotItemContextMenuButton"



const ImportantHint = () => {


    let [count, setCount] = useState<number>(0)


    
        const handleWheel = (e: React.WheelEvent<HTMLDivElement>) => {
            e.preventDefault();
            if (e.deltaY > 0)
                setCount(max([count-1, 0]) ?? 0)
            else
                setCount(min([count +1, 14]) ?? 0);
        }

    return <Box display={"flex"} alignItems={"center"}>
        <Box width={"20px"} sx={{fontWeight: "bold", fontSize: "20px"}} onClick={() => setCount(min([count +1, 14]) ?? 0)} onContextMenu={(e) => {e.preventDefault(); setCount(max([count-1, 0]) ?? 0)}} onWheel={handleWheel}>{count}</Box>
        <LocationQueryAutocomplete sx={{width: "200px"}} />
        {Array.from(Array(count), (e, i) => {
            return <OotItemContextMenuButton />
        })}
    </Box>
}
export default ImportantHint